import http from "./http";

export type FeatureFlag = {
	key: string;
	label: string;
	desc: string;
	risky: boolean;
	/** null = chưa từng lưu DB → coi như false */
	dbEnabled: boolean | null;
	/** null = không có env override tầng server */
	envOverride: boolean | null;
	/** true khi đang bị env đè → nút bấm chưa có hiệu lực tức thì */
	locked: boolean;
	/** trạng thái THẬT mà khách đang chịu */
	effective: boolean;
};

export async function getFeatureFlags(): Promise<FeatureFlag[]> {
	const { data } = await http.get("/admin/feature-flags");
	return Array.isArray(data?.flags) ? data.flags : [];
}

export async function updateFeatureFlag(
	key: string,
	enabled: boolean
): Promise<{ flag: FeatureFlag; message: string }> {
	const { data } = await http.put(`/admin/feature-flags/${key}`, { enabled });
	return data;
}
